// extracted by mini-css-extract-plugin
export default {"goback__mobile":"GoBackMobile_goback__mobile__ORM9o","icon":"GoBackMobile_icon__nomXS"};